// TODO: Obter códigos de serviço de uma API/endpoint em vez de lista hardcoded
// Lista de códigos de serviço disponíveis (exemplos)
export const availableServiceCodes = [
  { code: "6201-5/01", label: "6201-5/01 - Desenvolvimento de programas de computador sob encomenda" },
  { code: "6202-3/00", label: "6202-3/00 - Desenvolvimento e licenciamento de programas de computador customizáveis" },
  { code: "6203-1/00", label: "6203-1/00 - Desenvolvimento e licenciamento de programas de computador não customizáveis" },
  { code: "6204-0/00", label: "6204-0/00 - Consultoria em tecnologia da informação" },
  { code: "6209-1/00", label: "6209-1/00 - Suporte técnico, manutenção e outros serviços em tecnologia da informação" },
  { code: "7490-1/04", label: "7490-1/04 - Serviços de consultoria em gestão empresarial" },
  { code: "8599-6/99", label: "8599-6/99 - Outras atividades de ensino não especificadas anteriormente" },
  { code: "6311-9/00", label: "6311-9/00 - Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet" },
];
